import { render, staticRenderFns } from "./divertuser.vue?vue&type=template&id=1e45b7c9&"
import script from "./divertuser.vue?vue&type=script&lang=ts&"
export * from "./divertuser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "divertuser.vue"
export default component.exports